import Variable from './model.js'
import { deepGet, addToCollection } from '../shared/helper'

export default {
  namespaced: true,
  state: {
    variables: [],
    filteredCollection: [],
    current: new Variable(),
    currentCustomerId: null,
    customerOperators: null,
    customerInputs: null,
  },
  getters: {
    getCollection: state => state.variables,
    getFilteredCollection: state => state.filteredCollection,
    getById: state => (id) => state.variables.find(variable => variable.id === id),
    getCurrent: state => state.current,
    getCurrentCustomerId: state => state.currentCustomerId,
    getCustomerOperators: state => state.customerOperators,
    getCustomerInputs: state => state.customerInputs,
  },
  actions: {
    getCollection ({ commit, getters, state }, payload) {
      // add customer ID
      if (state.currentCustomerId) {
        const unparsed = JSON.parse(payload.search)
        unparsed.push({customer_id: state.currentCustomerId})
        payload.search = JSON.stringify(unparsed)
      }

      delete payload.id

      return this.dispatch('get', {
        path: 'v1/customerFields?include=operators',
        ...payload
      }).then((res) => {

        const data = deepGet(res, 'body.data')
        if (data) {

          const models = data.map((variable) => {
            commit('addVariableToCollection', { variableData: variable })
            return getters.getById(variable.id)
          })

          commit('addVariableToFilteredCollection', models)

          return { data: models, meta: res.body.meta }
        }
        return res
      })
    },
    create ({ commit, getters }, model) {
      return this.dispatch('post', {
        path: 'v1/customerFields',
        data: model.getJSON()
      }).then((res) => {

        commit('addVariableToCollection', { variableData: res.body && res.body.data })

        return getters.getById(res.body && res.body.data.id)
      })
    },
    update ({ commit, getters }, model) {
      return this.dispatch('put', {
        path: 'v1/customerFields/' + model.id,
        data: model.getJSON()
      }).then((res) => {

        commit('addVariableToCollection', { variableData: res.body && res.body.data })

        return getters.getById(res.body && res.body.data.id)
      })
    },
    delete ({ commit }, model) {
      return this.dispatch('del', {
        path: 'v1/customerFields/' + model.id,
        data: model
      }).then((res) => {

        commit('removeVariableFromCollection', model.id)

        return res
      })
    },
    loadCustomerVariableOperators({ commit, state }) {
      if (state.customerOperators) {
        return Promise.resolve()
      }

      return this.dispatch('get', {
        path: 'v1/customerFields/operators',
      }).then((res) => {
        const data = deepGet(res, 'body.data')
        if (data) {
          commit('updateCustomerOperators', { customerOperators: data })
        }
        return res
      })
    },
    loadCustomerVariableInputs({ commit, state }) {
      if (state.customerInputs) {
        return Promise.resolve()
      }

      return this.dispatch('get', {
        path: 'v1/customerFields/inputs',
      }).then((res) => {
        const data = deepGet(res, 'body.data')
        if (data) {
          commit('updateCustomerInputs', { customerInputs: data })
        }
        return res
      })
    },
  },
  mutations: {
    addVariableToCollection(state, { variableData, opts }) {
      addToCollection(this, state.variables, variableData, Variable, opts)
    },
    addVariableToFilteredCollection(state, data) {
      state.filteredCollection = state.filteredCollection.concat(data)
    },
    removeVariableFromCollection(state, variableId) {
      const index = state.variables.findIndex(el => el.id === variableId)

      if (index === -1) {
        console.warn(`Could not find/delete variable ${variableId}`)
        return
      }

      state.variables.splice(index, 1)
    },
    clearCollection(state) {
      state.variables = []
    },
    clearFilteredCollection(state) {
      state.filteredCollection = []
    },
    updateCurrent(state, variable) {
      state.current = variable
    },
    resetCurrent(state) {
      state.current = new Variable()
    },
    updateCurrentCustomerId(state, id) {
      state.currentCustomerId = id
    },
    updateCustomerOperators(state, { customerOperators }) {
      state.customerOperators = customerOperators
    },
    updateCustomerInputs(state, { customerInputs }) {
      state.customerInputs = customerInputs
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/variable/store.js